import type { ReactNode } from 'react';

import { Badge } from '@/components/common/Badge/Badge';

import { classNames } from '@/utils/classNames';

import styles from '@/styles/layout.module.css';

type StepHeaderProps = {
  title: string;
  description: string;
  kicker?: string;
  actions?: ReactNode;
  className?: string;
};

export function StepHeader({
  title,
  description,
  kicker,
  actions,
  className,
}: StepHeaderProps): JSX.Element {
  return (
    <section className={classNames(styles.stepHeader, className)}>
      <div className={styles.stepHeaderTop}>
        <div>
          {kicker ? <Badge tone="neutral">{kicker}</Badge> : null}
          <h1 className={styles.stepTitle}>{title}</h1>
          <p className={styles.stepDescription}>{description}</p>
        </div>
        {actions ? <div className={styles.stepActions}>{actions}</div> : null}
      </div>
    </section>
  );
}
